import React, { useRef, useState } from "react";

import styled from "styled-components/macro";

import { DateTime } from "luxon";

import FnrButton from "UI/FnrButton3";
import FnrConfirmationPopover from "UI/FnrConfirmationPopover";

import { Body, Link, Title, TitleIcon, TitleWrapper, Wrapper } from "./Styles";
import cross from "./lent_ttj_cross.png";

export default function LentTTJFlyers({ settings }) {
  const { isSuperAdmin, isGroupAdminForAnyGroup, everyoneGroupHasTTJ } =
    settings;
  const triggerRef = useRef();
  const [showTTJAlert, setShowTTJAlert] = useState(false);

  const toggleTTJAlert = () => setShowTTJAlert(!showTTJAlert);

  const shouldDisplay = () => {
    const isAdmin = isSuperAdmin || isGroupAdminForAnyGroup;

    const today = DateTime.now().ts;
    const startDisplayDate = DateTime.fromISO("2025-02-01").ts;
    const finalDisplayDate = DateTime.fromISO("2025-04-21").ts;
    const todayIsWithinDateRange =
      today >= startDisplayDate && today <= finalDisplayDate;

    if (isAdmin && todayIsWithinDateRange) {
      return true;
    } else {
      return false;
    }
  };

  if (!shouldDisplay()) return null;

  return (
    <StyledWrapper>
      <TitleWrapper>
        <TitleIcon>
          <Icon src={cross} />
        </TitleIcon>
        <TitleCustom>
          Download Text&#8209;to&#8209;Join Flyers for Lent &amp; Easter!
        </TitleCustom>
      </TitleWrapper>

      <BodyCustom>
        We&apos;ve designed some handy flyers that you can use this season to
        connect with visitors at your church. Click below to download for free!
      </BodyCustom>

      {everyoneGroupHasTTJ ? (
        <LinkCustom href="/flyer/lent2025" target="_blank" rel="noreferrer">
          Download seasonal flyers &gt;
        </LinkCustom>
      ) : (
        <span ref={triggerRef}>
          <LinkCustom onClick={toggleTTJAlert}>
            Download seasonal flyers &gt;
          </LinkCustom>
        </span>
      )}

      <FnrConfirmationPopover
        show={showTTJAlert}
        ref={triggerRef}
        onClose={toggleTTJAlert}
        message={
          <div>
            In order to use these flyers, you&apos;ll first need to set up a
            Text-to-Join Keyword for your Everyone group.
          </div>
        }
        button1={
          <a
            href="https://help.flocknote.com/article/29-what-is-text-to-join"
            target="_blank"
            rel="noreferrer"
          >
            <FnrButton text="Learn More" color="blue" />
          </a>
        }
        style={{ maxWidth: 240, padding: 10 }}
      />
    </StyledWrapper>
  );
}

const StyledWrapper = styled(Wrapper)`
  margin-top: 24px;
  background-color: none;
  box-shadow: none;
`;

const Icon = styled.img`
  width: 24px;
`;

const BodyCustom = styled(Body)`
  /* color: #542350 !important; */
`;

const LinkCustom = styled(Link)`
  cursor: pointer;
  color: #693065 !important;
`;

const TitleCustom = styled(Title)`
  color: #693065;
`;
